import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import customerSaga from './customers/saga';
import layoutSaga from './layout/saga';
import userSaga from './users/saga';
import productSaga from './products/saga';
import serviceSaga from './services/saga';
import EventsSaga from './events/saga';
import PoojariSaga from './poojari/saga';
import ritualSaga from './rituals/saga';
import templeSaga from './temples/saga';
import vendorSaga from './vendors/saga';
import stallSaga from './stalls/saga';
import templeAnalyticsSaga from './templeAnalytics/saga';
import orderSaga from './orders/saga';
import appVersionSaga from './appVersions/saga';
import categorySaga from './categories/saga';
import dashboardSaga from './dashboard/saga';
export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        userSaga(),
        customerSaga(),
        productSaga(),
        serviceSaga(),
        EventsSaga(),
        PoojariSaga(),
        ritualSaga(),
        templeSaga(),
        vendorSaga(),
        stallSaga(),
        templeAnalyticsSaga(),
        orderSaga(),
        appVersionSaga(),
        categorySaga(),
        dashboardSaga(),
    ]);
}
